import React, { Component } from 'react';
import EmailSignature from './EmailSignature.jsx';
import logo from './images/logo.png';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {

      // Email signature form.
      firstName: '',
      lastName: '',
      mobileNumber: '',
      jobTitle: '',
      email: '',
      copied: false,

    };

    this.iframe = React.createRef();
    this.handleChangeFirstName = this.handleChangeFirstName.bind(this);
    this.handleChangeLastName = this.handleChangeLastName.bind(this);
    this.handleChangeTitle = this.handleChangeTitle.bind(this);
    this.handleMobile= this.handleMobile.bind(this);
    this.handleEmail= this.handleEmail.bind(this);
    this.handleClickCopy= this.handleClickCopy.bind(this);
  }

    handleChangeFirstName(event) {
      this.setState({ firstName: event.target.value });
    }
    handleChangeLastName(event) {
      this.setState({ lastName: event.target.value });
    }

  handleChangeTitle(event){
    this.setState({ jobTitle: event.target.value});
  }

  handleMobile(event){
    this.setState({ mobileNumber: event.target.value});
  }
  handleEmail(event){
    this.setState({ email: event.target.value});
  }

    getIframe() {
    return this.iframe.current.iframe.current.contentDocument;
  }

    handleClickCopy(event) {
    event.preventDefault();

     const doc = this.getIframe();

     console.log(doc);
    
     doc.execCommand("selectAll");
     doc.execCommand("copy");

     this.setState({'copied': true });
  }

  render() {

            const { copied } = this.state;

    return (
      <div className="App">
        <header className="App-header">

          <div className="filter"></div>
          <div className="header-wrapper">
            <img src={logo} alt="brandbook"/>

          </div>
          <ul>
            <li>1. Fill in your details</li>
            <li>2. Click copy button</li>
            <li>3. Open Gmail > Settings > Command + V / Ctrl + V ( paste into signature box) > Save</li>
            <li>4. Done! </li>
          </ul>
        </header>
        <div className="line-one"></div>
        <p className="App-intro">
          <div className="field-wrapper">
            <h5>Enter your First Name</h5>
            <input value={this.state.firstName} onChange={this.handleChangeFirstName}/>
          </div>
          <div className="field-wrapper">
            <h5>Enter your Last Name</h5>
            <input value={this.state.lastName} onChange={this.handleChangeLastName}/>
          </div>
          <div className="field-wrapper">
            <h5>Enter your Job Title</h5>
            <input value={this.state.jobTitle} onChange={this.handleChangeTitle}/>
          </div>
          <div className="field-wrapper">
            <h5>Enter your Mobile Number</h5>
            <input value={this.state.mobileNumber} onChange={this.handleMobile}/>
          </div>
          <div className="field-wrapper">
            <h5>Enter your E-mail</h5>
            <input value={this.state.email} onChange={this.handleEmail}/>
          </div>
        </p>
        <div className="signature-container">

          <EmailSignature
            firstName={this.state.firstName}
            lastName={this.state.lastName}
            mobileNumber={this.state.mobileNumber}
            jobTitle={this.state.jobTitle}
            email={this.state.email}
            ref={this.iframe}
            />

            <button
            className="button copyButton"
            onClick={this.handleClickCopy}
            onBlur={this.handleBlurCopy}
            >
          { copied ? 'Copied!' : 'Copy' }
          </button>

        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js